<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('internalname')">
				Navn
			</th>
			<th class="sortable" @click="sort('type')">
				Type
			</th>
			<th class="sortable" @click="sort('price')">
				Pris
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(productpackage, index) in (sortedActivity, filteredList)" :key="index" @click="editProductPackage(productpackage)" :title="productpackage.description ? 'Beskrivelse: ' + productpackage.description : null">
					<td>
						{{ productpackage.internalname }}
						<div class="faded small">( {{ productpackage.name }} )</div>
					</td>
					<td>
						{{ getProductPackageType(productpackage) }}
					</td>
					<td>
						{{ productpackage.price }} kr.
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(productpackage, index) in (sortedActivity, filteredList)" :key="index" @click="editProductPackage(productpackage)">
					<td>
						<ul class="flex-content">
							<li data-label="Kunde">{{ productpackage.name }}</li>
							<li data-label="Type">{{ getProductPackageType(productpackage) }}</li>
							<li data-label="E-mail">{{ productpackage.price }} kr.</li>
					</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen produktpakker fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er endnu ikke oprettet nogen produktpakker
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types"
	import { productPackageTypeEnum } from "@/app/enums/common"

	export default {
		name: "ProductPackagesList",
		data: () => ({
			data: [],
			currentSort: "internalname",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html
				var productpackages = this.data
				return productpackages.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				var productpackages = this.data
				return productpackages.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase());
					let price = data.price.toString().toLowerCase().match(this.search.toLowerCase());
					return name || price;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		created()
		{
			this.loadData()
		},
		methods:
		{
			async loadData()
			{
				this.setComponentAsBusy()
				await this.$store.dispatch(types.ACTION_GET_PRODUCTPACKAGES)
					.then(response =>
					{
						this.data = response.data;
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("ProductPackagesList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					});
			},
			editProductPackage(productpackage)
			{
				this.$router.push({ name: "ProductPackageEdit", params: { productpackageid: productpackage.id } })
			},
			getProductPackageType(productpackage)
			{
				switch (productpackage.type)
				{
					case productPackageTypeEnum.PICTUREPACKAGE:
						return "Billedepakke"
					case productPackageTypeEnum.PICTUREPACKAGEEXTRA:
						return "Ekstra ved pakkekøb"
					case productPackageTypeEnum.WITHOUTPICTUREPACKAGE:
						return "Uden pakkekøb"
					case productPackageTypeEnum.ADDON:
						return "Tilkøbsprodukt"
					case productPackageTypeEnum.FREIGHTANDSERVICE:
						return "Fragt og service"
					case productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED:
						return "Fragt og service (Krævet)"
					case productPackageTypeEnum.AFTERPICTUREPACKAGE:
						return "Nyt motiv"
					case productPackageTypeEnum.PICTUREPACKAGESECONDARY:
						return "Billedepakke sekundær"
				}				
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
